/* cds-a11y-nav.js — mirror Empire's mobile nav accordion state into ARIA.
 *
 * Empire's mobile submenu tracks open/closed in `data-accordion-state` on the
 * `.navmenu-submenu` <ul>, but never updates `aria-expanded` on the controls
 * that open it. Measured on the live theme 2026-08-12: with the Support
 * submenu fully open (290px tall, items visible), both the parent
 * `.navmenu-link-parent` and the `.navmenu-button` toggle still reported
 * aria-expanded="false" — so a screen reader announces "collapsed" while the
 * menu is visibly expanded.
 *
 * This observes the attribute Empire *does* maintain and syncs the ARIA the
 * controls *should* expose. It changes no layout, no behaviour, and no visual
 * state; if the markup is ever absent it silently does nothing.
 *
 * Applies to every parent item in the mobile nav, not just Support.
 */
(function () {
  'use strict';

  if (!window.MutationObserver) return;

  /* Match on the class alone, NOT on [data-accordion-state]: Empire does not
     stamp that attribute until the first toggle, so an attribute-gated
     selector matches nothing at load and never binds. */
  var SUBMENU = '.navmenu-submenu';

  /* The controls that open a given submenu: Empire renders the parent link and
     a caret button as siblings of the <ul>, inside the same <li>. */
  function controlsFor(submenu) {
    var li = submenu.parentElement;
    if (!li) return [];
    return [].slice.call(
      li.querySelectorAll(':scope > .navmenu-link-parent, :scope > .navmenu-button, :scope > a[aria-expanded], :scope > button[aria-expanded]')
    );
  }

  /* Absent attribute === closed, which is Empire's pre-interaction state. */
  function sync(submenu) {
    var open = submenu.getAttribute('data-accordion-state') === 'open';
    controlsFor(submenu).forEach(function (ctrl) {
      if (ctrl.getAttribute('aria-expanded') !== String(open)) {
        ctrl.setAttribute('aria-expanded', String(open));
      }
    });
  }

  function watch(submenu) {
    if (submenu.__cdsA11yBound) return;
    submenu.__cdsA11yBound = true;
    new MutationObserver(function () { sync(submenu); }).observe(submenu, {
      attributes: true,
      attributeFilter: ['data-accordion-state']
    });
    sync(submenu); // establish the correct initial value
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    [].slice.call(scope.querySelectorAll(SUBMENU)).forEach(watch);
  }

  function init() {
    scan(document);

    /* Empire builds the mobile nav from a template on first open, so submenus
       can appear after load. Watch for them rather than assuming they exist. */
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SUBMENU)) watch(n);
          else scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
